<template>
  <form @submit.prevent="submitPersonalInfo" class="grid gap-4 grey-layout--increase-gap">
    <section class="grid gap-x-4 gap-y-4 grid-cols-1 md:grid-cols-2 md:gap-4">
      <div class="grid md:grid-cols-2 gap-4 col-span-full">
        <div class="label">
          <label for="dob">*Date of birth/ जन्म की तारीख</label>
          <input
            type="date"
            name="dob"
            placeholder="DD/MM/YYYY"
            v-model="params.personalInfo.dob"
            class="input"
            required
            :max="maxDate"
            min="1900-01-01"
          />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-x-4 justify-items-start col-span-full">
          <label for="gender" class="col-span-full text-gray-600 text-xs">Gender*</label>
          <div class="flex">
            <radio-button
              label="Male"
              name="gender"
              id="male"
              :required="true"
              value="Male"
              @change="saveValue"
              :checked="params.personalInfo.gender === 'Male'"
              class="mr-4"
            />
            <radio-button
              label="Female"
              name="gender"
              id="female"
              :required="true"
              value="Female"
              @change="saveValue"
              :checked="params.personalInfo.gender === 'Female'"
              class="mr-4"
            />
            <radio-button
              label="Other"
              name="gender"
              id="other"
              :required="true"
              @change="saveValue"
              :checked="params.personalInfo.gender === 'Other'"
              value="Other"
            />
          </div>
        </div>
    </section>
    <section class="grid gap-x-4 gap-y-4 grid-cols-1 md:grid-cols-2 md:gap-4">
      <p class="col-span-full text-black font-semibold text-sm">Address as per ID Proof</p>
      <div class="label">
        <label for="residential-address">*Address Line/पता</label>
        <input
          type="text"
          name="Residential Address"
          id="residential-address"
          class="input uppercase"
          placeholder="Enter Residential Address"
          v-model.trim="params.personalInfo.addressAsPerId.line1"
          required
          minlength="5"
          maxlength="100"
        />
      </div>
      <div class="label">
        <label for="pincode">*Pincode/पिन कोड</label>
        <input
          type="text"
          inputmode="numeric"
          name="Pincode"
          id="pincode"
          class="input"
          placeholder="Enter Pincode"
          maxlength="6"
          minlength="6"
          pattern="[0-9]{6}"
          v-model.trim="params.personalInfo.addressAsPerId.pincode"
          required
          @keypress="isNumber"
        />
      </div>
      <div class="label">
        <label for="city">*City/शहर</label>
        <input
          type="text"
          name="City"
          id="city"
          class="input"
          placeholder="Enter City"
          v-model.trim="params.personalInfo.addressAsPerId.city"
          required
          :disabled="disableCityStateResidence"
        />
      </div>
      <div class="label">
        <label for="state">*State/राज्य</label>
        <input
          type="text"
          name="State"
          id="state"
          class="input"
          placeholder="Enter State"
          v-model.trim="params.personalInfo.addressAsPerId.state"
          required
          :disabled="disableCityStateResidence"
        />
      </div>
    </section>
    <custom-button
      variant="primary"
      type="submit"
      class="md:justify-self-center"
      :loading="loading"
    >Save & Continue/ आगे बढ़े</custom-button>
  </form>
  <error-message-popup
    v-if="errorPopupMessage"
    @close-modal="errorPopupMessage = undefined"
    :errorPopupMessage="errorPopupMessage"
    :routeLink="$route.meta.isEdit ? 'Pre Approval Review' : 'Business Registration'"
    actionButtonText="Ok"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import CustomButton from './CustomButton.vue';
import ErrorMessagePopup from './ErrorMessagePopup.vue';
import RadioButton from './RadioButton.vue';

export default {
  name: 'PersonalProfileStep2',
  components: {
    CustomButton,
    ErrorMessagePopup,
    RadioButton
  },
  computed: {
    ...mapGetters(['applicationId', 'skipBusinessProfileInReferral', 'flagsData', 'videoVerified', 'flagsAllData']),
    maxDate() {
      const date = new Date();
      const maxDate = new Date(
        new Date().setUTCFullYear(date.getUTCFullYear() - 18)
      );
      return `${maxDate.getUTCFullYear()}-${(
        maxDate.getUTCMonth() + 1
      ).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}-${maxDate.getUTCDate().toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}`;
    },
  },
  mounted() {
    this.init();
  },
  emits: ['completed'],
  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      params: {
        personalInfo: {
          dob: undefined,
          gender: undefined,
          addressAsPerId: {
            pincode: undefined,
            line1: undefined,
            city: undefined,
            state: undefined
          }
        },
      },
      disableCityStateResidence: undefined,
      loading: undefined,
      errorPopupMessage: undefined,
    };
  },
  watch: {
    'params.personalInfo.addressAsPerId.pincode': function getPincode() {
      this.disableCityStateResidence = false;
      if (
        this.params.personalInfo.addressAsPerId.pincode &&
        this.params.personalInfo.addressAsPerId.pincode.length === 6 &&
        this.params.personalInfo.addressAsPerId.pincode.match(/[0-9]{6}/)
      ) {
        this.getPincode(this.params.personalInfo.addressAsPerId.pincode)
          .then((result) => {
            if (result.state !== undefined && result.city !== undefined) {
               this.params.personalInfo.addressAsPerId.state = result.state;
              this.params.personalInfo.addressAsPerId.city = result.city;
              this.disableCityStateResidence = true;
            } else {
             this.disableCityStateResidence = false;
              this.params.personalInfo.addressAsPerId.state = "";
              this.params.personalInfo.addressAsPerId.city = "";
            }
          })
          .catch(() => {
            this.disableCityStateResidence = false;
          });
      }
    },

  },
  methods: {
    init() {
      this.getApplicationPersonalInfo().then((result) => {
        this.params.personalInfo.dob = result?.personalInfo?.dob;
        this.params.personalInfo.addressAsPerId.line1 =
          result?.personalInfo?.addressAsPerId?.line1;
        this.params.personalInfo.addressAsPerId.pincode =
          result?.personalInfo?.addressAsPerId?.pincode;
        this.params.personalInfo.addressAsPerId.city =
          result?.personalInfo?.addressAsPerId?.city;
        this.params.personalInfo.addressAsPerId.state =
          result?.personalInfo?.addressAsPerId?.state;
        this.params.personalInfo.gender =
          result?.personalInfo?.gender;
      });
    },
    getPincode(pincode) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('getPincode', pincode)
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveValue(event) {
      this.params.personalInfo.gender = event.target.value;
    },
    saveMaritalStatus(event) {
      this.params.personalInfo.maritalStatus = event.target.value;
    },
    submitPersonalInfo() {
      this.loading = true;
      this.$store
        .dispatch('v4ApplicationPersonalInfo', {
          applicationId: this.applicationId,
          patchParams: this.params,
          urlParams: {
            review: !!this.$route.meta.isEdit,
          },
        })
        .then((response) => {
          this.loading = false;
          if (response.subStatus === "personalInfoUpdated") {
            if (this.flagsAllData?.currentAddressRequired) {
                this.$router.push({
                  name: 'Personal Address',
                });
              } else if (this.flagsData.faceVerificationEnabled && !this.videoVerified) {
              this.$router.push({
                name: 'Video Verification',
                query: {
                    redirect: 'video-verification-signup',
                  },
              });
            } else if (this.skipBusinessProfileInReferral && !this.$route.meta.isEdit) {
                this.getApprovals();
              } else {
                this.$emit('completed', this.stepNumber + 1);
              }
            } else if (response.subStatus === "businessInfoUpdated") {
              this.$router.push({ name: 'Pre Approval Review' });
            }
          })
        .catch(() => {
          this.loading = false;
        });
    },
    getApplicationPersonalInfo() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('getApplicationPersonalInfo', {
            applicationId: this.applicationId,
          })
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    getApprovals() {
      this.$store.dispatch('applicationApprovals', {
        applicationId: this.applicationId,
        urlParams: { option: 'best' },
      }).then((result) => {
        this.loading = false;
     if (result.showApproval) {
          if (result?.result[0]?.amountApproved > 0) {
          this.$router.push({
            name: 'Pre Approval Congratulations',
            query: {
              nextRoute: 'Pre Approval Review',
            }
          });
        } else if (result?.result[0]?.amountApproved === 0 || result?.result[0]?.amountApproved === undefined) {
          this.$router.push({
            name: 'Pre Approval Review',
            params: {
              applicationId: this.applicationId,
            },
          });
        }
      } else {
          this.$emit('completed', this.stepNumber + 1);
        }
      }).catch(() => {
        this.loading = false;
      });
    }

  },
};
</script>
